import { render } from "./ExtendedSurveillance.vue?vue&type=template&id=9079b330"
import script from "./ExtendedSurveillance.vue?vue&type=script&lang=js"
export * from "./ExtendedSurveillance.vue?vue&type=script&lang=js"

import "./ExtendedSurveillance.vue?vue&type=style&index=0&id=9079b330&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__